/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="stepper-container">
    <div class="stepper-wrapper desktop-only">
      <div v-for="(step, index) in steps" :key="index" class="step-item"
        :class="{ 'active': (index + 1) === currentStep, 'completed': (index + 1) < currentStep }">
        <div class="step-counter">
          <span v-if="(index + 1) < currentStep" class="check-mark">✓</span>
          <div v-else class="step-icon-svg" v-html="getStepIcon(step)"></div>
        </div>
        <div class="step-name">{{ step }}</div>
      </div>
    </div>

    <div class="mobile-stepper mobile-only">
      <div class="mobile-header">
        <div class="icon-container">
          <div class="icon-circle" v-html="getStepIcon(steps[currentStep - 1])"></div>
        </div>
        <div class="step-text">
          <p class="step-count">PASO {{ currentStep }} DE {{ steps.length }}</p>
          <h3 class="step-title">{{ steps[currentStep - 1] }}</h3>
        </div>
      </div>
      <div class="progress-bar-container">
        <div class="progress-bar-fill" :style="{ width: (currentStep / steps.length) * 100 + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
      default: () => ["Contacto", "Consumo", "Equipo", "Otros cargos", "Confirmación"]
    },
    currentStep: {
      type: Number,
      required: true,
      default: 1
    }
  },
  methods: {
    getStepIcon(stepName) {
      const name = stepName.toLowerCase();
      const props = 'width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';
      
      // Mapeo exacto según tus pasos
      if (name.includes('contacto')) {
        return `<svg ${props}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`;
      } 
      else if (name.includes('consumo')) {
        return `<svg ${props}><polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polyline></svg>`;
      } 
      else if (name.includes('equipo')) {
        return `<svg ${props}><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>`;
      } 
      else if (name.includes('cargo')) {
        return `<svg ${props}><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>`;
      }
      else if (name.includes('confirm')) {
        return `<svg ${props}><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>`;
      }
      
      return `<svg ${props}><circle cx="12" cy="12" r="10"></circle></svg>`;
    }
  }
}
</script>

<style scoped>
.mobile-only { display: none; }

.stepper-container {
  width: 100%;
  padding: 20px 0;
}

.stepper-wrapper {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 90%;
  margin: 0 auto;
}

.stepper-wrapper::before {
  content: '';
  position: absolute;
  top: 25px;
  left: 40px;
  right: 40px;
  height: 2px;
  background-color: #e5e7eb;
  z-index: 1;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1;
}

.step-counter {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  border: 2px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  transition: all 0.3s ease;
}

.step-name {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
}

.step-item.active .step-counter {
  border-color: #2a428c;
  color: #2a428c;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(152, 77, 33, 0.15);
}
.step-item.active .step-name { color: #2a428c; }

.step-item.completed .step-counter {
  background-color: #29b9f6;
  border-color: #29b9f6;
  color: #fff;
}
.step-item.completed .step-name { color: #2a428c; }

@media (max-width: 768px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }

  .mobile-stepper {
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    margin: 0 10px;
  }

  .mobile-header {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
  }

  .icon-container {
    border: 2px solid #29b9f6;
    border-radius: 50%;
    padding: 2px;
  }

  .icon-circle {
    width: 44px;
    height: 44px;
    background-color: #29b9f6;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .step-count {
    margin: 0;
    font-size: 11px;
    color: #9ca3af;
    font-weight: 800;
    letter-spacing: 1px;
  }

  .step-title {
    margin: 0;
    font-size: 19px;
    color: #1f2937;
    font-weight: 700;
  }

  .progress-bar-container {
    width: 100%;
    height: 8px;
    background-color: #f3f4f6;
    border-radius: 10px;
    overflow: hidden;
  }

  .progress-bar-fill {
    height: 100%;
    background-color: #29b9f6;
    transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
</style>